import axios from "axios";
import store from "../store";

import treatments from "./treatments.js"
import csv from "../components/workers/csv/main.js"

class Workers {

	async execute(name, params, data)
	{
		if (name == "csv")
		{
			var result = await csv.main(params, data)
			console.log(result)
			return result;
		}
	}

	async get_params(data)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/workers/browser", data, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					console.log(error);
				});
		});
	}

	async gpt_cost(project_uid, steps, configuration)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/workers/gpt_cost", { project_uid, steps, configuration}, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					console.log(response.data)
					resolve(response.data.cost);
				})
				.catch(function (error) {
					console.log(error);
				});
		});
	}

	async gpt_list_cost(service)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/workers/gpt_list_cost", { service }, {
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(function (response) {
					console.log(response.data)
					resolve(response.data.cost);
				})
				.catch(function (error) {
					console.log(error);
				});
		});
	}

	async test(data, step, element_set_progress) {
		let jwt = store.state.jwt;

		console.log("test")

		return new Promise(function (resolve, reject) {
			axios
				.post(`${process.env.VUE_APP_SAAS_BACK}` + "/workers", data, {
					timeout: 1000 * 60 * 60,
					onUploadProgress: function (progressEvent) {
						var percentCompleted = Math.round(
							(progressEvent.loaded * 100) / progressEvent.total
						);
						if (percentCompleted == 100) {
							if (step) 
								step.set_time("dowload");
						}
						if (element_set_progress)
							element_set_progress.set_progress(percentCompleted)
					},
					headers: { Authorization: "Bearer " + jwt },
				})
				.then(async function (response) {
					if (response.data.data.timeout)
					{
						console.log("timeout");

						var data = null;
						while (!data)
						{
							await new Promise((resolve) =>
								setTimeout(resolve, 15000)
							);
							data = await treatments.getFileAlyx("/" + response.data.data.uid, false, false);
							if (data.status == 204)
								data = null;
						}
						if (step) 
							step.set_time("treatment");
						console.log({error: null, status: 200, data: data})
						resolve({error: null, status: 200, data: data});
					}
					else
					{
						if (step) 
							step.set_time("treatment");
						console.log(response.data)
						resolve(response.data);
					}
				})
				.catch(function (error) {
					console.log(error);
					if (step) {
						if (error.response && error.response.status == "500")
							step.set_time("error");
						else step.set_time("error timeout");
					}
					console.log("error : " + error);
					reject(error)
				});
		});
	}
}

export default new Workers();
